import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Button from '../UI/Button/Button';
import Input from '../UI/Input/Input';
import styles from './MovieReminderSubscriptionForm.module.css';
import Kinostyles from '../Util/AutokinoStylesComponent.module.css';
import { checkValidation } from '../../utils';
import ReCAPTCHA from 'react-google-recaptcha';

class MovieReminderSubscriptionForm extends Component {
  componentDidMount() {}

  state = {
    movieReminderSubscriptionForm: {
      mailadresse: {
        elementType: 'input',
        elementConfig: {
          type: 'email',
          placeholder: 'Emailadresse*',
        },
        value: '',
        validation: {
          required: true,
        },
        valid: true,
        touched: false,
      },
    },
    formIsValid: false,
  };

  inputChangedHandler = (event, inputID) => {
    const updatedForm = { ...this.state.movieReminderSubscriptionForm };
    const updatedFormElement = updatedForm[inputID];
    updatedFormElement.value = event.target.value;
    updatedFormElement.valid = checkValidation(
      updatedFormElement.value,
      updatedFormElement.validation
    );
    updatedFormElement.touched = true;
    updatedForm[inputID] = updatedFormElement;
    console.log('captchaconfirmed: ' + this.state.captchavalid);
    var formIsValid = false;
    if (!this.state.captchavalid) {
      formIsValid = false;
    } else {
      formIsValid = true;
    }

    // Check form is valid
    for (const key in updatedForm) {
      formIsValid = updatedForm[key].valid && formIsValid;
    }
    console.log('test from is valid,isValid = ' + formIsValid);

    this.setState({
      movieReminderSubscriptionForm: updatedForm,
      formIsValid: formIsValid,
    });
  };
  checkboxChangedHandler = (event, inputID) => {
    const updatedForm = { ...this.state.movieReminderSubscriptionForm };

    this.setState({
      movieReminderSubscriptionForm: updatedForm,
    });
  };
  saveMovieReminderSubscriptionForm = (event, registerData) => {
    //console.table(event);
    event.target.disabled = true;
    this.props.saveClicked(event, registerData);
  };

  onChange(value) {
    console.log('Captcha value:', value);

    this.setState({
      formIsValid: true,
      captchavalid: true,
    });
  }

  checkFormValid() {
    console.log('checkFormValid called');
    var valid = this.state.formIsValid;
    if (!this.state.captchaconfirmed || this.state.captchaconfirmed === '') {
      valid = false;
      this.props.addNotification(
        null,
        'Bitte bestätigen Sie die Auswahl "Ich bin kein Roboter"'
      );
    }
    console.log('checkFormValid result: ' + valid);
    return false;
  }

  renderInputs = form => {
    return Object.entries(form).map(([key, value]) => (
      <div key={key} className={[styles[key], styles.FormElements].join(' ')}>
        <label>
          {value.elementConfig ? value.elementConfig.placeholder : ''}
        </label>
        <Input
          elementConfig={value.elementConfig}
          inputType={value.elementType}
          value={value.value}
          changed={event => this.inputChangedHandler(event, key)}
          invalid={!value.valid}
          touched={value.touched}
          shouldValidate={value.validation}
        />
      </div>
    ));
  };

  getFormData(form) {
    const emailadresse = form['mailadresse'].value;
    const data = {
      email: emailadresse,
    };

    console.log('emailSubscriptionForm = ' + JSON.stringify(data));

    return data;
  }

  render() {
    const registerData = this.getFormData(
      this.state.movieReminderSubscriptionForm
    );
    return (
      <div className={'mt-4 ml-4 mr-4'}>
        <form className={styles.Form}>
          <div className={styles.FormWrapper}>
            {this.renderInputs(this.state.movieReminderSubscriptionForm)}
          </div>
          <div className="NewsletterCheckbox">
            <input
              type="checkbox"
              onChange={event =>
                this.checkboxChangedHandler(event, 'newsletterAutokino')
              }
              value="true"
              name="newsletterAutokino"
            />
            <div style={{ marginLeft: '20px' }}>
              Ich bin damit einverstanden, dass meine Daten für eine spätere
              Kontaktaufnahme elektronisch verarbeitet und gespeichert werden.
            </div>
          </div>
          <ReCAPTCHA
            sitekey="6LfpQqImAAAAAGXhl-_HpXq2eneR7xFk1Gkes4xe"
            onChange={value => this.onChange(value)}
          />
          <div className={styles.Container + ' mt-4'}>
            {
              <Button
                clicked={e =>
                  this.state.formIsValid
                    ? this.saveMovieReminderSubscriptionForm(e, registerData)
                    : this.props.addNotification(
                        e,
                        'Bitte geben Sie alle Pflichtfelder ein (mit * gekennzeichnet) und bestätigen Sie die Auswahl "Ich bin kein Roboter"!'
                      )
                }
                theme="big"
                className={[Kinostyles.CTAButton].join(' ')}
              >
                Jetzt vormerken
              </Button>
            }
          </div>
        </form>
      </div>
    );
  }
}

MovieReminderSubscriptionForm.propTypes = {
  isSigningUp: PropTypes.bool,
  saveClicked: PropTypes.func,
  addNotification: PropTypes.func,
  formData: PropTypes.object,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    isSigningUp: state.auth.loading,
    formData: state.formData,
  };
};

export default connect(mapStateToProps)(MovieReminderSubscriptionForm);
